import { createIconComponent } from '../../factory/create-icon-component';
export const CollapseIcon = createIconComponent(
  'CollapseIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 4L7.26274 9.73726C6.47071 10.5293 6.07469 10.9253 5.92631 11.382C5.7958 11.7837 5.7958 12.2163 5.92631 12.618C6.07469 13.0747 6.47071 13.4707 7.26274 14.2627L13 20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 8L13 11L12 12L13 13L16 16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
